var angular = require('angular')

angular.module('AemTransparentAccount')
  .factory('appDataservice', appDataservice)

appDataservice.$inject = []

function appDataservice () {
  var self = {
    state: {
      backendError: null
    }
  }

  return self
}
